import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=2309f0fd&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_453bf6d7/src/components/button/Circle.vue').default})
